import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setTawkWidgetHidden } from "../utils/tawkChat";

// Paths (and their sub-routes) where the Tawk.to chat widget should be hidden
const ADMIN_PATH_PREFIXES = [
  "/admin",
  "/staff-management",
  "/pending-admins",
  "/mobile-app-manager",
  "/suspended-users",
  "/create-admin",
  "/create-permissions",
];

const isAdminPath = (pathname) =>
  ADMIN_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));

/**
 * Hides the Tawk.to chat widget on admin-related routes, since admin
 * staff don't need the customer support chat bubble.
 */
export default function TawkVisibility() {
  const { pathname } = useLocation();

  useEffect(() => {
    setTawkWidgetHidden(isAdminPath(pathname));
  }, [pathname]);

  return null;
}
